import React, { useState, useEffect } from "react";
import Notiflix from "notiflix";

// ANT DESIGN IMPORTS
import {
  Spin,
  Space,
  Button,
  Input,
  Divider,
  Modal,
  Row,
  Col,
  Form,
  Tooltip,
} from "antd";
import {
  PlusCircleOutlined,
  FolderOpenOutlined,
  EditOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import { apiConfig, labelConfig } from "../../../../customer.config";
import styles from "../../../../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";
import { useNavigate } from "react-router-dom";

const DetailLimit = (props) => {
  const { currentCustomerObj, userData, limitObj, refreshList } = props;
  const { session } = userData;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [limitDetail, setLimitDetail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [inputField, setInputField] = useState([]);
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const docTypeName = Form.useWatch("name", useForm);

  useEffect(() => {}, []);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${apiConfig.ClientLimit}/details`;

    const params = {
      limitLineNumber: limitObj?.limitLineNo,
    };

    let body = {
      session,
      params,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setLimitDetail(objDetail);

        setInputField([
          {
            name: labelConfig.liabilityId,
            value: objDetail?.liabilityId,
            type: "general",
          },
          {
            name: labelConfig.limitLineNo,
            value: objDetail?.limitLineNumber,
            type: "general",
          },
          {
            name: labelConfig.currency,
            value: objDetail?.currency?.code,
            type: "general",
          },

          {
            name: labelConfig.liabilityCategory,
            value: objDetail?.liabilityCategory,
            type: "general",
          },
          {
            name: labelConfig.limitAmount,
            value: Number(objDetail?.accountLimit).toLocaleString(),
            type: "general",
          },
          {
            name: labelConfig.status,
            value: objDetail?.isActive ? "Active" : "Inactive",
            type: "general",
          },
          {
            name: labelConfig.revolvingLine,
            value: objDetail?.revolvingLine ? "Yes" : "No",
            type: "general",
          },
          {
            name: labelConfig.retrieveCollateral,
            value: objDetail?.retrieveCollaterals ? "Yes" : "No",
            type: "general",
          },
          {
            name: labelConfig.limitEndDate,
            value: BOM.FormatArrayDate(objDetail?.limitEndDate),
            type: "general",
          },
          {
            name: labelConfig.globalLimit,
            value: objDetail.globalLimit,
            type: "amount",
          },
          {
            name: labelConfig.accountLimit,
            value: objDetail.accountLimit,
            type: "amount",
          },
          {
            name: labelConfig.cardLimit,
            value: objDetail.cardLimit,
            type: "amount",
          },
          {
            name: labelConfig.utilizedLimit,
            value: objDetail.utilizedLimit,
            type: "utilization",
          },
          {
            name: labelConfig.unUsedLimit,
            value: objDetail.unUsedLimit,
            type: "utilization",
          },
          {
            name: labelConfig.unAuthorisedLimit,
            value: objDetail.unAuthorisedLimit,
            type: "utilization",
          },
          // {
          //   name: labelConfig.digitsAfterDecimal,
          //   value: objDetail.currency?.digitsAfterDecimal,
          //   type: "utilization",
          // },
          // {
          //   name: labelConfig.inMultiplesOf,
          //   value: objDetail.currency?.inMultiplesOf,
          //   type: "utilization",
          // },
        ]);

        setIsLoading(false);
      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
    getDetailById();
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onUpdateStatus = (key) => {
    let action = `${key.isActive ? labelConfig.close : labelConfig.reOpen} `;
    let label = key.liabilityCategory;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${apiConfig.ClientLimit}/updateStatus`;
        const params = {
          limitLineNumber: limitObj?.limitLineNo,
        };
        const body = {
          method: "PUT",
          isActive: !key.isActive,
          session,
          params,
        };

        // message.warning(
        //   "Close or Re-Open module is not ready require some works from the backend"
        // );
        // return;
        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.updateLimitMsg);

              // close modal
              setIsModalOpen(false);

              //refresh the list
              refreshList();

              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              setIsLoading(false);
            },
          }
        );
      },
      function () {
        // No button
      }
    );
  };

  return (
    <>
      <Tooltip title={`View Detail`}>
        <Button
          type="primary"
          icon={<FolderOpenOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Limit Detail"
        centered
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={800}
        style={{
          height: 600,
          overflow: "auto",
        }}
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Form layout="vertical" form={useForm}>
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Space size="small">
                <Button
                  type="primary"
                  shape="round"
                  className="of-primaryBtnColor"
                  onClick={() => onUpdateStatus(limitDetail)}
                  danger={limitDetail.isActive ? true : false}
                >
                  {`${
                    limitDetail.isActive
                      ? labelConfig.close
                      : labelConfig.reOpen
                  } Limit`}
                </Button>
              </Space>
            </div>
            <Row>
              <Divider orientation="left">{labelConfig.generalInfo}</Divider>
              {inputField.map(
                (item, index) =>
                  item?.type?.toLowerCase() === "general" && (
                    <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={item.name}>
                        <Input
                          disabled
                          value={item.value}
                          className="of-bold-disable-input"
                        />
                      </Form.Item>
                    </Col>
                  )
              )}
            </Row>

            {/* <Row>
              <Divider orientation="left">
                {labelConfig.amountInformation}
              </Divider>
              {inputField.map(
                (item, index) =>
                  item?.type?.toLowerCase() === "amount" && (
                    <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={item.name}>
                        <Input
                          disabled
                          value={item.value}
                          className="of-bold-disable-input"
                        />
                      </Form.Item>
                    </Col>
                  )
              )}
            </Row>
            <Row>
              <Divider orientation="left">
                {labelConfig.utilizationInformation}
              </Divider>
              {inputField.map(
                (item, index) =>
                  item?.type?.toLowerCase() === "utilization" && (
                    <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={item.name}>
                        <Input
                          disabled
                          value={item.value}
                          className="of-bold-disable-input"
                        />
                      </Form.Item>
                    </Col>
                  )
              )}
            </Row> */}
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

export default DetailLimit;
